var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Interactive-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_MSO-Company-Charting-Interactive-State---Overlays-2",
    transform: "translate(-1352.000000, -1037.000000)",
    fill: "#B7B7B7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(22.000000, 1025.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(1291.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(31.500000, 18.000000) rotate(-180.000000) translate(-31.500000, -18.000000) translate(8.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30979133,14.2817485 L12.5911898,9.001 L0.800012059,9 C0.389737204,9 0.0515950492,8.61395981 0.00538226619,8.11662113 L0,8 C0,7.48716416 0.308836808,7.06449284 0.706713753,7.00672773 L0.800012059,7 L12.5921898,7.001 L7.30979133,1.71825146 C6.37073029,0.779204581 7.77932185,-0.629365743 8.71838288,0.309681139 L15.4670971,7.05698908 C15.7466547,7.18060263 15.9548553,7.49294618 15.9936999,7.87152276 L15.9997345,8.00733648 C16.0005926,8.04222541 15.9993476,8.07415535 15.9963323,8.10619292 C15.9627828,8.49505309 15.7519944,8.81703628 15.4670971,8.94301092 L8.71838288,15.6903189 C7.77932185,16.6293657 6.37073029,15.2207954 7.30979133,14.2817485 Z",
    id: "Path-Copy-313",
    transform: "translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowInactive);
export default __webpack_public_path__ + "static/media/UpArrowInactive.1622d91f59a743156ca941c6845b1218.svg";
export { ForwardRef as ReactComponent };